import { render, staticRenderFns } from "./SectionCui.vue?vue&type=template&id=3096cd4c&scoped=true"
import script from "./SectionCui.vue?vue&type=script&lang=js"
export * from "./SectionCui.vue?vue&type=script&lang=js"
import style0 from "./SectionCui.vue?vue&type=style&index=0&id=3096cd4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3096cd4c",
  null
  
)

export default component.exports